import React from 'react';

import { useContext as useHomeContext } from 'components/Members/Home/Context';

import Breadcrumbs from 'components/new_ui/Breadcrumbs/Index';
import Resources from './Resources';

export default function Index() {
  const context = useHomeContext();

  const breadcrumbs = [
    {
      name: 'Home',
      path: '/members/home',
    },
    {
      name: 'Resources',
    },
  ];

  return (
    <div className="content">
      {context && <Breadcrumbs breadcrumbs={breadcrumbs} />}
      <Resources />
    </div>
  );
}
